import { loginFieldsRegex, signUpTabs } from 'constants/storage'
import TextInputField from 'components/input'
import { Controller, useFormContext } from 'react-hook-form'
import { Tab } from '@headlessui/react'
import CustomHeadlessTabs from 'components/CustomHeadlessTabs'

export default function TabSignIn({ selectedTab, setSelectedTab }) {
  const { control, formState } = useFormContext()

  return (
    <Tab.Group
      onChange={(index) =>
        setSelectedTab(index === 0 ? signUpTabs.EMAIL : signUpTabs.CELLPHONE)
      }
    >
      <CustomHeadlessTabs className='mt-5' tabs={['Email o DNI', 'Celular']} />
      <Tab.Panels className='w-full transition-all duration-200'>
        <Tab.Panel className='p-1'>
          <div>
            <Controller
              rules={{
                required: {
                  value: selectedTab === signUpTabs.EMAIL,
                  message: 'Ingresá un email/DNI válido'
                },
                maxLength: 127
              }}
              name='email'
              control={control}
              defaultValue=''
              render={({ field: { value, onChange, name } }) => (
                <TextInputField
                  value={value}
                  name={name}
                  onChange={onChange}
                  isError={!!formState.errors.email}
                  errorMessage={formState.errors?.email?.message}
                  id='emailInput'
                  inputType='text'
                  margins='my-0'
                  label='DNI o Email'
                  maxLength={127}
                />
              )}
            />
            <Controller
              rules={{
                required: selectedTab === signUpTabs.EMAIL,
                maxLength: 127
              }}
              name='password'
              control={control}
              render={({ field: { value, onChange, name } }) => (
                <TextInputField
                  value={value}
                  name={name}
                  onChange={onChange}
                  id='passwordInput'
                  inputType='password'
                  label='Contraseña'
                  margins='mt-3 mb-2'
                  maxLength={127}
                />
              )}
            />
          </div>
        </Tab.Panel>
        <Tab.Panel className='p-1 w-full'>
          <div>
            <Controller
              rules={{
                required: {
                  value: selectedTab === signUpTabs.CELLPHONE,
                  message: 'Ingresá un CELULAR válido'
                },
                pattern: loginFieldsRegex.NUMERIC,
                maxLength: 10
              }}
              name='cellphone'
              control={control}
              render={({ field: { value, onChange, name } }) => (
                <TextInputField
                  value={value}
                  name={name}
                  onChange={({ target: { value } }) => {
                    if (!loginFieldsRegex.NUMERIC.test(value)) return
                    onChange(value)
                  }}
                  isError={!!formState.errors.cellphone}
                  errorMessage={formState.errors?.cellphone?.message}
                  id='phoneInput'
                  inputType='tel'
                  margins='my-0'
                  maxLength='10'
                  placeholder='Ingresá tu celular'
                />
              )}
            />
            <p className='mt-2 font-bold text-xs leading-tight text-gray-600'>
              Incluye el código de área de tu ciudad, sin el 0 y sin el 15.
            </p>
          </div>
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  )
}
